export const enum RateType {
  monthly = 'month',
  annually = 'annual',
}
